<template>
<div class="CreateChallengeDiv">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-1Perc margin-top-1Perc cursor-pointer" v-on:click="updateCreateChallengeOverlay($event,false)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Title
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="challengeObj.Title">
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-lg-6"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-Left-0px padding-right-0Px">
                  Description
                </div>
                <div class="col-md-9 col-lg-9">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <textarea class="form-control" rows="5" v-model="challengeObj.Desc"/>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-Left-0px padding-right-0Px">
                  Context
                </div>
                <div class="col-md-9 col-lg-9">
                  <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                      <div class="col-sm-12 padding-left-0px padding-right-0px">
                        <tinymce id="d1" v-model="challengeObj.Context"></tinymce>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  TLQ(s)
                </div>
                <div class="col-md-9 col-lg-9">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <textarea class="form-control" rows="5" v-model="challengeObj.TrafficLightQuestions"/>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Rating Question
                </div>
                <div class="col-md-9 col-lg-9">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="challengeObj.RatingQuestion">
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Feedback Question
                </div>
                <div class="col-md-9 col-lg-9">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="challengeObj.TextFeedbackQuestion">
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-Left-0px padding-right-0Px">
                  Challenge Video
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <video-quality-control :parentElementObj="videoUrlObj" :currQualityType="constants.Video_Quality.Q_360" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control>
                      <video-quality-control :parentElementObj="videoUrlObj" :currQualityType="constants.Video_Quality.Q_Auto" :disableInputBox="false" @updatedValue="updateVideoQualityValue"></video-quality-control>
                      <video-quality-control :parentElementObj="videoUrlObj" :currQualityType="constants.Video_Quality.Q_720" :disableInputBox="disableInputBoxFor360And720" @updatedValue="updateVideoQualityValue"></video-quality-control>
                    </div>
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Faculty Response Video
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <video-quality-control :parentElementObj="videoUrlObjForFaculty" :currQualityType="constants.Video_Quality.Q_360" :disableInputBox="disableFVInputBoxFor360And720" @updatedValue="updateVideoQualityValueForFacultyVideos"></video-quality-control>
                      <video-quality-control :parentElementObj="videoUrlObjForFaculty" :currQualityType="constants.Video_Quality.Q_Auto" :disableInputBox="false" @updatedValue="updateVideoQualityValueForFacultyVideos"></video-quality-control>
                      <video-quality-control :parentElementObj="videoUrlObjForFaculty" :currQualityType="constants.Video_Quality.Q_720" :disableInputBox="disableFVInputBoxFor360And720" @updatedValue="updateVideoQualityValueForFacultyVideos"></video-quality-control>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <!-- VTT file start -->
             <div class="row vertical-align margin-bottom-2Perc">
              <div class="col-md-1 col-lg-1">
              </div>  
              <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                Challenge Caption File
              </div>
              <div class="col-md-4 col-lg-4">
                <div class="form-group">
                  <div class="col-sm-12">
                    <input type="file" id="challengeVttFile" accept=".vtt">
                  </div>
                </div>
              </div>
              <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                Faculty Caption File
              </div>
              <div class="col-md-4 col-lg-4">
                <div class="form-group">
                  <div class="col-sm-12">
                    <input type="file" id="facultyVttFile" accept=".vtt">
                  </div>
                </div>
              </div>  
            </div>
            <!-- VTT file end -->
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
                  Topic
                </div>
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                      <div class="col-sm-12">
                        <select class="form-control Padding-right-0px" v-model="getSelectedTopicId">
                          <option value=-1 disabled>Select</option>
                          <option v-for="topicObj in getTopicList" v-bind:key="topicObj.TopicId" v-bind:value="topicObj.TopicId">{{ topicObj.TopicName }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px padding-Left-0px">
                  Silhoutee2 Name
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="challengeObj.Silhoutee2Name">
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Designation1
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="challengeObj.Designation1">
                    </div>
                  </div>
                </div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px padding-Left-0px padding-bottom-15px">
                  Designation2
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="text" class="form-control" v-model="challengeObj.Designation2">
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px padding-Left-0px">
                  Silhoutee2 Image
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <input type="file" id='silhoutee2Img' accept=".png,.jpg,.jpeg">
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-lg-6">
                </div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2 padding-Left-0px">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="createChallenge">Create Challenge</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row"></div>  
            </div>
          </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
 </div>
 </div>
</template>

<script>
import { topicService } from '@/server-util/topic-service'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { challengeService } from '@/server-util/challenge-service'
import tinymce from 'vue-tinymce-editor'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import VideoQualityControl from '@/components/VideoQualityControl'
export default {
  created: function () {
    this.getTopics()
  },
  data: function () {
    return {
      constants: constants,
      showAlertDialog: false,
      errorMsg: '',
      videoUrlObj: {
        LowQualityVideoUrl: '',
        HDVideoUrl: '',
        VideoUrl: ''
      },
      videoUrlObjForFaculty: {
        LowQualityVideoUrl: '',
        HDVideoUrl: '',
        VideoUrl: ''
      },
      disableInputBoxFor360And720: true,
      disableFVInputBoxFor360And720: true,
      challengeObj: {
        Title: '',
        Desc: '',
        Context: '',
        VideoUrl: '',
        ChallengeVideoHDUrl: '',
        ChallengeVideoLQUrl: '',
        FacultyResponseVideoLQUrl: '',
        FacultyVideoUrl: '',
        FacultyResponseVideoHDUrl: '',
        TrafficLightQuestions: '',
        RatingQuestion: '',
        TextFeedbackQuestion: '',
        Silhoutee1Name: '',
        Silhoutee2Name: '',
        Silhoutee2Image: '',
        Designation1: '',
        Designation2: '',
        TopicId: -1
      }
    }
  },
  name: 'CreateChallengeDiv',
  methods: {
    updateVideoQualityValue (value) {
      console.log('Emitted with: ', value)
      const videoUrl = value.videoUrl
      const currQualityType = value.currQualityType
      switch (parseInt(currQualityType)) {
        case parseInt(constants.Video_Quality.Q_360):
          console.log('360 ' + videoUrl)
          this.LowVideoURLValue = videoUrl
          this.ChallengeResponseLQVideoUrlValue = videoUrl
          break
        default:
        case parseInt(constants.Video_Quality.Q_Auto):
          console.log('Auto ' + videoUrl)
          this.VideoURLValue = videoUrl
          this.ChallengeResponseVideoUrlValue = videoUrl
          if (this.ChallengeResponseVideoUrlValue.trim().length === 0) {
            this.LowVideoURLValue = ''
            this.ChallengeResponseLQVideoUrlValue = ''
            this.HDVideoURLValue = ''
            this.ChallengeResponseHDVideoUrlValue = ''
            this.disableInputBoxFor360And720 = true
          } else {
            this.disableInputBoxFor360And720 = false
          }
          break
        case parseInt(constants.Video_Quality.Q_720):
          console.log('720 ' + videoUrl)
          this.HDVideoURLValue = videoUrl
          this.ChallengeResponseHDVideoUrlValue = videoUrl
          break
      }
    },
    updateVideoQualityValueForFacultyVideos (value) {
      console.log('Emitted with: ', value)
      const videoUrl = value.videoUrl
      const currQualityType = value.currQualityType
      switch (parseInt(currQualityType)) {
        case parseInt(constants.Video_Quality.Q_360):
          console.log('360 ' + videoUrl)
          this.FVLowVideoURLValue = videoUrl
          this.FacultyResponseLQVideoUrlValue = videoUrl
          break
        default:
        case parseInt(constants.Video_Quality.Q_Auto):
          console.log('Auto ' + videoUrl)
          this.FVVideoURLValue = videoUrl
          this.FacultyResponseVideoUrlValue = videoUrl
          if (this.FacultyResponseVideoUrlValue.trim().length === 0) {
            this.FVLowVideoURLValue = ''
            this.FacultyResponseLQVideoUrlValue = ''
            this.FVHDVideoURLValue = ''
            this.FacultyResponseHDVideoUrlValue = ''
            this.disableFVInputBoxFor360And720 = true
          } else {
            this.disableFVInputBoxFor360And720 = false
          }
          break
        case parseInt(constants.Video_Quality.Q_720):
          console.log('720 ' + videoUrl)
          this.FVHDVideoURLValue = videoUrl
          this.FacultyResponseHDVideoUrlValue = videoUrl
          break
      }
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    },
    getTopics: function () {
      var _this = this
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== '' &&
        storeObj.state.access_token !== null
      ) {
        if (storeObj.state.topicList.length === 0) {
          // AK: Start showing spinner only if topic list not found
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }

        topicService.getAllTopics(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.topicList = responseObj.data
              // AK: Hide Spinner if its showing to user
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              // console.log(JSON.stringify(storeObj.state.topicList))
            } else {
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.showAlertDialog = true
              _this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner if its showing to user
            // _this.showSpinner = false
            this.$store.state.isLoading = false
            _this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log(
          'ACCESS TOKEN is NULL hence declined GET TOPIC LIST OPERATION'
        )
      }
    },
    updateCreateChallengeOverlay: function (event, flagToUpdate) {
      this.$emit('closeCreateOverlay', flagToUpdate)
    },
    chekcSilhouteeFileExtesion: function (fileName) {
      var exts = ['.png', '.jpeg', '.jpg']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    createChallenge: function () {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var fileUrl = document.getElementById('silhoutee2Img').files[0]
        if (fileUrl !== undefined) {
          if (
            !this.chekcSilhouteeFileExtesion(
              document.getElementById('silhoutee2Img').value
            )
          ) {
            this.showAlertDialog = true
            this.errorMsg = 'Invalid file format selected for Silhoutee2.'
            return
          }
        }
        var challengeVttFileUrl = document.getElementById('challengeVttFile').files[0]
        if (challengeVttFileUrl === undefined && challengeVttFileUrl === null) {
          challengeVttFileUrl = null
        }
        var facultyVttFileUrl = document.getElementById('facultyVttFile').files[0]
        if (facultyVttFileUrl === undefined && facultyVttFileUrl === null) {
          facultyVttFileUrl = null
        }
        // console.log('Create >>>>' + JSON.stringify(this.challengeObj))
        // alert(JSON.stringify(this.challengeObj))
        const formData = new FormData()
        formData.append('Title', this.challengeObj.Title)
        formData.append('Desc', this.challengeObj.Desc)
        if (this.challengeObj.Context !== undefined && this.challengeObj.Context !== 'undefined' && this.challengeObj.Context !== null && this.challengeObj.Context !== 'null' && this.stripHtml(this.challengeObj.Context).length > 0) {
          formData.append('Context', this.challengeObj.Context)
        } else {
          formData.append('Context', null)
        }
        formData.append('TrafficLightQuestions', this.challengeObj.TrafficLightQuestions)
        formData.append('RatingQuestion', this.challengeObj.RatingQuestion)
        formData.append('TextFeedbackQuestion', this.challengeObj.TextFeedbackQuestion)
        const videoUrl = this.challengeObj.VideoUrl !== '' ? this.challengeObj.VideoUrl.trim() : ''
        formData.append('VideoUrl', videoUrl)
        const hdVideoUrl = this.challengeObj.ChallengeVideoHDUrl !== '' ? this.challengeObj.ChallengeVideoHDUrl.trim() : ''
        formData.append('ChallengeVideoHDUrl', hdVideoUrl)
        const lowVideoUrl = this.challengeObj.ChallengeVideoLQUrl !== '' ? this.challengeObj.ChallengeVideoLQUrl.trim() : ''
        formData.append('ChallengeVideoLQUrl', lowVideoUrl)
        const facultyVideoUrl = this.challengeObj.FacultyVideoUrl !== '' ? this.challengeObj.FacultyVideoUrl.trim() : ''
        formData.append('FacultyVideoUrl', facultyVideoUrl)
        const facultyHdVideoUrl = this.challengeObj.FacultyResponseVideoHDUrl !== '' ? this.challengeObj.FacultyResponseVideoHDUrl.trim() : ''
        formData.append('FacultyResponseVideoHDUrl', facultyHdVideoUrl)
        const facultyLowVideoUrl = this.challengeObj.FacultyResponseVideoLQUrl !== '' ? this.challengeObj.FacultyResponseVideoLQUrl.trim() : ''
        formData.append('FacultyResponseVideoLQUrl', facultyLowVideoUrl)
        formData.append('Silhoutee1Name', this.challengeObj.Silhoutee1Name)
        formData.append('Silhoutee2Name', this.challengeObj.Silhoutee2Name)
        formData.append('Designation1', this.challengeObj.Designation1)
        formData.append('Designation2', this.challengeObj.Designation2)
        formData.append('Silhoutee2ImageFile', fileUrl)
        formData.append('TopicId', this.challengeObj.TopicId)
        formData.append('ChallengeVideoVttFileInput', challengeVttFileUrl)
        formData.append('facultyVideoVttFileInput', facultyVttFileUrl)
        var storeObj = this.$store
        if (
          storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
        ) {
          // AK: Start showing Spinner
          this.$emit('showSpinner', true)
          challengeService
            .createChallenge(
              storeObj.state.access_token,
              formData
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Hide showing Spinner
                this.$emit('showSpinner', false)
                // AK: to reset filter
                this.$store.state.isChallengeCreated = true
                // AK: Store it
                storeObj.state.challengeList.push(responseObj.data)
                // console.log(JSON.stringify(responseObj.data))
                // AK: Hide Create Challenge Overlay
                this.$emit('closeCreateOverlay', false)
              } else {
                // AK: Hide Spinner
                this.$emit('showSpinner', false)
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              this.$emit('showSpinner', false)
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Access Token is NULL hence declined CREATE NEW Challenge'
          )
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    validateRequiredFieldBeforeSubmit: function () {
      var challengeVttFileUrl = document.getElementById('challengeVttFile').files[0]
      var facultyVttFileUrl = document.getElementById('facultyVttFile').files[0]
      if (this.challengeObj.Title.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        return false
      } else if (this.challengeObj.Desc.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Description can\'t be empty.'
        return false
      } else if (this.challengeObj.TrafficLightQuestions.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Traffic light question can\'t be empty.'
        return false
      } else if (this.challengeObj.RatingQuestion.length > 0 && (!this.challengeObj.RatingQuestion.replace(/\s/g, '').length)) {
        this.showAlertDialog = true
        this.errorMsg = 'Rating question can\'t only have empty spaces.'
        return false
      } else if (this.LowVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.LowVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.LowVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Low Quality Video url.'
        return false
      } else if (this.VideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.VideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.VideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Auto Quality Video url.'
        return false
      } else if (this.HDVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.HDVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.HDVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid High Quality Video url.'
        return false
      } else if (this.FVLowVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.FVLowVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.FVLowVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Low Quality Faculty Video url.'
        return false
      } else if (this.FVVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.FVVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.FVVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Auto Quality Faculty Video url.'
        return false
      } else if (this.FVHDVideoURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.FVHDVideoURLValue.trim()) || !dmAdminUtils.checkForVideoFileExtesion(this.FVHDVideoURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid High Quality Faculty Video url.'
        return false
      } else if (this.challengeObj.TopicId === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select topic.'
        return false
      } else if (this.challengeObj.Silhoutee2Name.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Silhoutee2 name can\'t be empty.'
        return false
      } else if (challengeVttFileUrl !== undefined && challengeVttFileUrl !== null && !this.checkVttFileExtesion(document.getElementById('challengeVttFile').value)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a valid .vtt file for challenge video caption file.'
        return false
      } else if (facultyVttFileUrl !== undefined && facultyVttFileUrl !== null && !this.checkVttFileExtesion(document.getElementById('facultyVttFile').value)) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a valid .vtt file for faculty Response video caption file.'
        return false
      }
      return true
    },
    checkVttFileExtesion: function (fileName) {
      var exts = ['.vtt']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    }
  },
  components: {
    'alert-box': AlertBox,
    'tinymce': tinymce,
    'video-quality-control': VideoQualityControl
  },
  computed: {
    getSelectedTopicId: {
      get: function () {
        return this.challengeObj.TopicId
      },
      set: function (newValue) {
        this.challengeObj.TopicId = newValue
      }
    },
    getTopicList: {
      get: function () {
        return this.$store.state.topicList
      }
    },
    VideoURLValue: {
      get: function () {
        return this.videoUrlObj.VideoUrl
      },
      set: function (newValue) {
        this.videoUrlObj.VideoUrl = newValue
      }
    },
    HDVideoURLValue: {
      get: function () {
        return this.videoUrlObj.HDVideoUrl
      },
      set: function (newValue) {
        this.videoUrlObj.HDVideoUrl = newValue
      }
    },
    LowVideoURLValue: {
      get: function () {
        return this.videoUrlObj.LowQualityVideoUrl
      },
      set: function (newValue) {
        this.videoUrlObj.LowQualityVideoUrl = newValue
      }
    },
    FVVideoURLValue: {
      get: function () {
        return this.videoUrlObjForFaculty.VideoUrl
      },
      set: function (newValue) {
        this.videoUrlObjForFaculty.VideoUrl = newValue
      }
    },
    FVHDVideoURLValue: {
      get: function () {
        return this.videoUrlObjForFaculty.HDVideoUrl
      },
      set: function (newValue) {
        this.videoUrlObjForFaculty.HDVideoUrl = newValue
      }
    },
    FVLowVideoURLValue: {
      get: function () {
        return this.videoUrlObjForFaculty.LowQualityVideoUrl
      },
      set: function (newValue) {
        this.videoUrlObjForFaculty.LowQualityVideoUrl = newValue
      }
    },
    FacultyResponseVideoUrlValue: {
      get: function () {
        return this.challengeObj.FacultyVideoUrl
      },
      set: function (newValue) {
        this.challengeObj.FacultyVideoUrl = newValue
      }
    },
    FacultyResponseLQVideoUrlValue: {
      get: function () {
        return this.challengeObj.FacultyResponseVideoLQUrl
      },
      set: function (newValue) {
        this.challengeObj.FacultyResponseVideoLQUrl = newValue
      }
    },
    FacultyResponseHDVideoUrlValue: {
      get: function () {
        return this.challengeObj.FacultyResponseVideoHDUrl
      },
      set: function (newValue) {
        this.challengeObj.FacultyResponseVideoHDUrl = newValue
      }
    },
    ChallengeResponseVideoUrlValue: {
      get: function () {
        return this.challengeObj.VideoUrl
      },
      set: function (newValue) {
        this.challengeObj.VideoUrl = newValue
      }
    },
    ChallengeResponseLQVideoUrlValue: {
      get: function () {
        return this.challengeObj.ChallengeVideoLQUrl
      },
      set: function (newValue) {
        this.challengeObj.ChallengeVideoLQUrl = newValue
      }
    },
    ChallengeResponseHDVideoUrlValue: {
      get: function () {
        return this.challengeObj.ChallengeVideoHDUrl
      },
      set: function (newValue) {
        this.challengeObj.ChallengeVideoHDUrl = newValue
      }
    }
  }
}
</script>

<style scoped>
.red{
  background-color: red;
}
.red-border {
  border: 1px solid red !important;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2% !important;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 16px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.create-lesson-label-text-style {
  color: #34495e;
  font-size: 12px;
}
.red-border{
  border: 1px solid red;
}
.padding-left-1Point8{
  padding-left:1.8%  
}
.border-red {
  border: 1px solid red
}
.padding-bottom-15px {
  padding-bottom:15px;
}
.padding-left-0px {
  padding-left: 0px;
}
.padding-right-0px {
  padding-right: 0px;
}
</style>





// WEBPACK FOOTER //
// src/components/CreateChallengeOverlay.vue